import * as yup from "yup";
import { Validation } from "../../utils/Validation.utils";
export const SimpleEmailTemplateInitialValues = {
    subject: "",
    body: ""
};
export const SimpleEmailTemplateSchema = yup.object().shape({
    subject: yup.string().trim().required(Validation.Required),
    body: yup.string().trim().required(Validation.Required)
});
